import React from "react";

import {
  Facebook,
  Instagram,
  TelephoneFill,
  GeoAltFill,
  EnvelopeFill,
  Linkedin,
  Youtube,
  ChevronDown,
  GeoAlt,
  Envelope,
  Phone,
  Telephone,
} from "react-bootstrap-icons";
import logo from "../images/logo/logo.png";
import { Link, navigate } from "gatsby";
import {
  footer as footerToken,
  layout,
  heading,
  text,
  button,
  hyperlink,
  spacing,
  contactCard,
} from "../tokens";
import ContentWrapper from "./ContentWrapper";
import { StaticImage } from "gatsby-plugin-image";
import { contactInfo } from "../contactInfo";

interface FooterProps {
  children?: any;
  karnet?: boolean;
  hideMenu?: boolean;
  data?: any;
  indexPage?: boolean;
}

export const Footer: React.FC<FooterProps> = () => {
  const footer = footerToken();
  const hyperlinkToken = hyperlink();
  const headingToken = heading();
  const textToken = text();
  const layoutToken = layout();
  const buttonToken = button();
  const spacingToken = spacing();
  const contactCardToken = contactCard();

  return (
    <>
      <footer className={footer.wrapper}>
        <ContentWrapper className={footer.container} Tag="section">
          <span className={hyperlinkToken.copy}>@2025 Weronika Filas</span>
          <span
            className={hyperlinkToken.base}
            style={{ textDecoration: "none", pointerEvents: "none" }}
          >
            <GeoAltFill />
            Poznań Głogowska 70/7 Domofon 71
          </span>
        </ContentWrapper>
      </footer>
    </>
  );
};
